module.exports = __webpack_public_path__ + "static/media/PICCO_2023.bb55f098.png";